import { BaseComponent } from './BaseComponent';
import { debounce } from './Utils/Utils';

const DEFAULT_RESIZE_EVENT_TIME = 50;

export class ResizeService extends BaseComponent {
    private element: HTMLElement;
    private resizeObserver: ResizeObserver | null = null;
    private debounceResize: any;

    constructor(element: HTMLElement) {
        super();

        this.element = element;

        this.initResizeObserver();
    }

    destroy() {
        this.destroyResizeObserver();
    }

    private initResizeObserver() {
        this.debounceResize = debounce(this.onResize.bind(this), DEFAULT_RESIZE_EVENT_TIME);

        this.resizeObserver = new ResizeObserver(this.debounceResize);

        this.resizeObserver.observe(this.element);
    }

    private destroyResizeObserver() {
        if (this.resizeObserver) {
            this.resizeObserver.unobserve(this.element);
        }

        this.resizeObserver = this.debounceResize = null;
    }

    private onResize(entries: any) {
        const entry = entries[0];

        if (entry.target !== this.element) {
            return;
        }

        this.emit('resize');
    }
}
